import { IPropertyInfoMetadata } from "../../../DotNet/SeriouslyRAD.Framework/Reflection/IPropertyInfoMetadata";
import { EntityBaseProperties, IEntityBaseProperties } from "./EntityBaseProperties";

export interface IReferenceNumberEntityProperties extends IEntityBaseProperties
{
    referenceNumber: IPropertyInfoMetadata;
}

export const ReferenceNumberEntityProperties: IReferenceNumberEntityProperties = {

    ...EntityBaseProperties,

    referenceNumber: {
        attributes: [
            {
                $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                description: "Reference Number"
            },
            {
                $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                displayName: "Reference Number"
            }
        ],
        name: "ReferenceNumber",
        propertyTypeId: "System.Int32, System.Private.CoreLib",
        $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
    },

};